import { isRequiredText, strMax } from '../../../utils';
export const clientAdviceValidate = {
    content: [
        isRequiredText('お問合せ内容を入力してください'),
        strMax(2000, 'お問合せ内容は2000文字以内で入力してください'),
    ],
};
export default clientAdviceValidate;
